"use strict";

function mapValues(object, fn) {
  var result = {};
  Object.keys(object).forEach(function (key) {
    var value = fn(object[key]);

    if (value !== undefined) {
      result[key] = value;
    }
  });
  return result;
}

module.exports = {
  mapValues: mapValues
};